import api from 'networkapp-api-connector';

export async function demoMode({ event, csrfToken , userId}) {
    // Configure API access
    api.setBaseURL(location.origin + '/api');
    api.setCSRFToken(csrfToken);

    // start demo mode
    app.store.dispatch(app.actions.demo.start(event, userId));
}
